import { render, staticRenderFns } from "./ERROR_404.vue?vue&type=template&id=28afea16&scoped=true&"
import script from "./ERROR_404.vue?vue&type=script&lang=js&"
export * from "./ERROR_404.vue?vue&type=script&lang=js&"
import style0 from "./ERROR_404.vue?vue&type=style&index=0&id=28afea16&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28afea16",
  null
  
)

export default component.exports